module.exports = __webpack_public_path__ + "statics/img/yhz5m.68ff62e9.png";